import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "confirmationTextInput",
    "confirmationTextLabelInput",
    "openTicketContainer",
    "redirectUrlContainer",
    "redirectUrlInput",
    "redirectUrlOrOpenTicketSelect",
  ];

  connect() {
    this.#resetFields(this.redirectUrlOrOpenTicketSelectTarget.value);
  }

  changeType(event) {
    const selectedType = event.target.value;

    this.openTicketContainerTarget.classList.toggle("hidden", selectedType !== "open_ticket");
    this.redirectUrlContainerTarget.classList.toggle("hidden", selectedType !== "redirect_url");

    this.#resetFields(selectedType);
  }

  #resetFields(selectedType) {
    if (selectedType === "open_ticket") {
      this.redirectUrlInputTarget.value = "";
    } else if (selectedType === "redirect_url") {
      this.confirmationTextInputTarget.value = "";
      this.confirmationTextLabelInputTarget.value = "";
    } else {
      this.redirectUrlInputTarget.value = "";
      this.confirmationTextInputTarget.value = "";
      this.confirmationTextLabelInputTarget.value = "";
    }
  }
}
